import React, { useState } from "react";
import {
    Container,
    Header,
    SpaceBetween,
    Button
} from "@amzn/awsui-components-react";
import "../../css/errorSummary.css"
import { getUserAlias } from "../../utils/utils";
import { modifyWorkflowStatus } from "../redux/exceptionAPIs";
import { ACKNOWLEDGEMENT_STRUCTURE_MAP_KEY, ASM_COMPLETE_STATUS } from "../common/constants";
import QuickSightFrame from "../common/QuickSightFrame";

export default function ViewDashboards(props) {
    const {
        exceptionData,
        setStepsStateHandler,
        updateWorkflowStatusDispatcher,
        isUnderReview,
        stepsState,
        parentWorkflowId,
        useCase
    } = props;

    const [completeButtonState, setCompleteButtonState] = useState(false);

    const completeButtonClickHandler = async () => {
        setCompleteButtonState(true);
        const userAlias = await getUserAlias();
        const request = {
            parentWorkflowId: parentWorkflowId,
            acknowledgementStructureMap: {
                [ACKNOWLEDGEMENT_STRUCTURE_MAP_KEY.Insight]: { status: ASM_COMPLETE_STATUS, user: userAlias }
            },
        };
        const onSuccess = () => {
            setStepsStateHandler("insightStep");
        };
        modifyWorkflowStatus(updateWorkflowStatusDispatcher, request, onSuccess);
        setCompleteButtonState(false);
    };

    const isCompleteButtonDisabled = () => {
        return !(isUnderReview && !stepsState.insightStep.completed);
    };

    return (
        <Container
            header={<Header actions={
                <SpaceBetween size="s" direction="horizontal">
                    <Button onClick={completeButtonClickHandler}
                            disabled={isCompleteButtonDisabled() || completeButtonState}>Acknowledge</Button>
                </SpaceBetween>
            }></Header>}>
            <QuickSightFrame linkKey={'INSIGHTS'}
                             exceptionData={exceptionData}
                             useCase={useCase}/>
        </Container>
    );
}